var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-container"},[_c('d-header',{attrs:{"fluid":"","breadcrumbs":false,"actions":[
      {
        label: _vm.$t('new_owner_contact'),
        resource: 'ownerContact',
        path: 'contacts/create',
        primary: true,
        color: 'is-primary'
      }
    ]}},[_c('h2',{staticClass:"title is-5"},[_vm._v("\n      "+_vm._s(_vm.$t("owner_contacts").capitalize())+"\n    ")])]),_vm._v(" "),_c('v-owner-contact-list',{attrs:{"owner_id":_vm.model.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }